import { useTheme } from "@mui/material";
import React from "react";
import { HashLoader } from "react-spinners";

export default function Splash() {
    const theme = useTheme();

    return (
        <div
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <HashLoader
                color={theme.palette.primary.main}
                size={theme.spacing(12)}
            />
        </div>
    );
}
